import React, { Component } from 'react';
import Page from './components/Page';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Page />
      </div>
    );
  }
}

export default App;
